const commonEn = {
  navigation: {
    portfolio: "Portfolio",
    services: "Sessions",
    pricing: "Pricing",
    about: "About",
    contact: "Contact",
  },

  pages: {
    home: "Home",
    portfolio: "Portfolio",
    services: "Sessions",
    pricing: "Pricing",
    about: "About",
    contact: "Contact",
    notFound: "Page not found",
  },

  /*
    ==========================================================
    HERO
    ==========================================================
  */

  hero: {
    eyebrow: "Photography · Finland",

    title:
      "Moments worth returning to.",

    description:
      "Timeless photographs of people, emotions and stories worth remembering.",

    portfolio:
      "View portfolio",

    services:
      "Choose a session",

    scroll:
      "Scroll",
  },

  /*
    ==========================================================
    EDITORIAL INTRO
    ==========================================================
  */

  editorialIntro: {
    eyebrow:
      "Introduction",

    title:
      "Photographs do not stop time. They help us return to it.",

    description:
      "The most meaningful photographs grow from moments that do not need to be forced. A glance, a touch, laughter and everything that happens in between.",

    footer:
      "Honest moments · Timeless memories",
  },


  /*
    ==========================================================
    PORTFOLIO STORY
    ==========================================================
  */

  portfolioStory: {
    eyebrow: "Selected portfolio",

    title:
      "Stories in photographs.",

    previous:
      "Previous image",

    next:
      "Next image",

    swipe:
      "Swipe",

    items: {
      one: {
        category: "Wedding · Editorial",
        title: "Among the flowers",
        alt: "Wedding couple surrounded by flowers",
      },

      two: {
        category: "Bride · Portrait",
        title: "A quiet moment",
        alt: "Bridal portrait in natural light",
      },

      three: {
        category: "Wedding · Landscape",
        title: "Towards the light",
        alt: "Wedding couple in a sunset landscape",
      },

      four: {
        category: "Wedding day · Details",
        title: "The little things",
        alt: "Wedding day detail",
      },

      five: {
        category: "Story · Moments",
        title: "In the moment",
        alt: "Natural moment during a wedding day",
      },
    },
  },

  /*
    ==========================================================
    SESSIONS
    ==========================================================
  */

  sessionsSection: {
    eyebrow:
      "Sessions",

    title:
      "Every story has its own rhythm.",

    description:
      "Each session grows from the people, atmosphere and moment in front of the camera. The aim is not perfect posing, but photographs that feel genuinely yours.",

    allSessions:
      "Explore all sessions",

    items: {
      weddings: {
        eyebrow:
          "Weddings",

        title:
          "Your day.",

        description:
          "Documentary and timeless wedding photography, from the smallest details to the moments you never want to forget.",

        alt:
          "Wedding couple in a landscape",
      },

      couples: {
        eyebrow:
          "Couples",

        title:
          "Two people.",

        description:
          "A relaxed session without stiff posing — connection, movement and moments that feel like you.",

        alt:
          "Couple surrounded by flowers",
      },

      portraits: {
        eyebrow:
          "Portraits",

        title:
          "Simply you.",

        description:
          "Natural portraits where the focus is not on performing for the camera, but on being present as yourself.",

        alt:
          "Portrait in natural light",
      },
    },
  },

  /*
    ==========================================================
    ABOUT
    ==========================================================
  */

  aboutSection: {
    eyebrow:
      "About",

    intro:
      "Behind the camera",

    title:
      "Present in the moment.",

    description:
      "My role as a photographer is not to make a moment perfect, but to notice it as it naturally unfolds.",

    descriptionTwo:
      "I want being photographed to feel relaxed and genuine. When you can forget the camera for a moment, the photographs begin to hold something more meaningful than a pose.",

    link:
      "Meet the photographer",

    imageAlt:
      "Photographer",

    caption:
      "Photographer · Finland",

    quote:
      "In the best photographs, you do not only see what a moment looked like. You remember how it felt.",
  },

  /*
    ==========================================================
    CONTACT
    ==========================================================
  */

  contactSection: {
    eyebrow:
      "Contact",

    intro:
      "Let the story begin",

    title:
      "Tell me what you want to remember.",

    description:
      "Every session begins with an idea. Tell me about the day, the people or the moment you would like to preserve.",

    contact:
      "Get in touch",

    sessions:
      "Explore sessions",
  },

  footer: {
    tagline:
      "Timeless photographs of people, emotions and stories.",

    navigation:
      "Footer navigation",

    location:
      "Photography · Finland",
  },

  /*
    ==========================================================
    PORTFOLIO PAGE
    ==========================================================
  */

  portfolioPage: {
    eyebrow:
      "Portfolio · Selected stories",

    title:
      "Photographs worth returning to.",

    description:
      "A single photograph cannot hold an entire day. This portfolio is built from stories — glances, details, landscapes and everything that happens in between.",

    albumEyebrow:
      "Album stories",

    albumTitle:
      "Your story, as an album.",

    albumDescription:
      "Photographs are meant for more than scrolling. At their best, they become a story you will want to return to for years to come.",

    categories: {
      all:
        "All",

      weddings:
        "Weddings",

      couples:
        "Couples",

      portraits:
        "Portraits",
    },

    loadMore:
      "Load more",

    previous:
      "Previous story",

    next:
      "Next story",

    swipe:
      "Swipe",

    openImage:
      "Open image",

    closeImage:
      "Close image",

    lightbox:
      "Large photograph",

    ctaEyebrow:
      "Your story",

    ctaTitle:
      "The next story could be yours.",

    viewSessions:
      "Explore sessions",

  },
  demo: {
    eyebrow: "Photography Premium",

    title:
      "A digital space built around photography.",

    description:
      "A premium photography website foundation where content, themes, languages and branding can be changed without rewriting the template core.",

    portfolio:
      "View portfolio",

    services:
      "Choose a session",
  },

  controls: {
    language: "Language",
    theme: "Theme",
    menu: "Menu",
    openMenu: "Open menu",
    closeMenu: "Close menu",
  },

  notFound: {
    code: "404",

    title:
      "Page not found.",

    description:
      "The page you are looking for does not exist or its address has changed.",

    backHome:
      "Back to home",
  },
};

export default commonEn;
